import Joi from 'joi';

import { generateJoiValidation } from '@/shared/validations/generateJoiValidation';
import { PaymentTerm } from './paymentTerms.model';
import { objectId } from '@/shared/validations/custom.validation';

export const createPaymentTerm = () => ({
  body: generateJoiValidation(PaymentTerm.schema),
});

export const updatePaymentTerm = () => ({
  query: Joi.object().keys({
    id: Joi.string().custom(objectId).required(),
  }),
  body: generateJoiValidation(PaymentTerm.schema, true),
});

export const getPaymentTerm = {
  query: Joi.object().keys({
    name: Joi.string(),
    stage: Joi.string(),
    triggerType: Joi.string(),
    project: Joi.string().custom(objectId),
    sortBy: Joi.string(),
    search: Joi.string(),
    limit: Joi.number().integer().min(1),
    page: Joi.number().integer().min(-1),
    includeTimeStamps: Joi.boolean(),
  }),
};

export const getPaymentTermById = {
  params: Joi.object().keys({
    id: Joi.string().custom(objectId),
  }),
};

export const deletePaymentTermById = {
  params: Joi.object().keys({
    id: Joi.string().custom(objectId),
  }),
};
